import type { Offer } from "@/types/Offers";
import { useMoveManagerOfferPart } from "@/composables/moveManager/useMoveManagerOffer";
import { useMoveManagerPricePart } from "@/composables/moveManager/useMoveManagerPrice";
import { useMoveManagerMethodsPart } from "@/composables/moveManager/useMoveManagerMethods";
import {
	getMoveManagerOffer,
	getMoveManagerStore,
	createMoveManagerContext,
	type MoveManagerContext,
	type MoveManagerProps,
	type useMoveManagerOverrides,
} from "@/composables/moveManager/moveManagerBase";
import type { PropType } from "vue";

export const useMoveManagerEmits = ['update:offer'];

export const useMoveManagerProps = {
	offer: {
		type: Object as PropType<Offer | null>,
		default: null,
	},
};

export function useMoveManager(
	props?: MoveManagerProps,
	{ emit }: { emit: (event: string, ...args: unknown[]) => void } = { emit: () => {} },
	overrides?: useMoveManagerOverrides
) {
	const ctx = createMoveManagerContext(props);
	const { currentOffer } = ctx;
	const { demand, projectSelected, nbDaysBookingLimit, servicesPrice, servicesStore, offers, offersLoading, prebookDate } = ctx;

	const offerPart = useMoveManagerOfferPart({ offer: currentOffer }, ctx);

	const pricePart = useMoveManagerPricePart({ offer: currentOffer }, ctx);

	const methodsPart = useMoveManagerMethodsPart({ offer: currentOffer }, { emit }, overrides, ctx);

	return {
		demand,
		projectSelected,
		nbDaysBookingLimit,
		servicesPrice,
		servicesStore,
		offers,
		offersLoading,
		prebookDate,
		...offerPart,
		...pricePart,
		...methodsPart,
		currentOffer,
		...overrides,
	};
};

export { createMoveManagerContext, getMoveManagerOffer, getMoveManagerStore };
export type { useMoveManagerOverrides, MoveManagerContext };
